export default __webpack_public_path__ + "static/media/loader.b626eb53.gif";